<template>
  <div class="content">
    <div class="container-fluid mt-7">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template v-slot:header>
            <div class="row align-items-center py-4">
              <div class="col-lg-6 col-8">
                <h3 class="mb-0">Broker Table</h3>
              </div>
            </div>
          </template>
          <div>
            <div class="row flex-wrap mb-2 mb-md-0">
              <div class="col-12 col-md-2 mb-2 d-flex justify-content-start">
                <el-select class="w-100 ml-2 mr-2 pagination-select" v-model="perPage" placeholder="Per page"
                  @change="handlePerPageChange">
                  <el-option class="select-primary" v-for="item in perPageOptions" :key="item" :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 mt-lg-0  mb-2 d-flex justify-content-start">
                <el-select class="w-100 ml-2 mr-2 pagination-select" v-model="tempFilterField" placeholder="Filter by"
                  @change="handleTempFieldChange">
                  <el-option class="select-primary" v-for="item in fieldOptions" :key="item" :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 d-flex justify-content-center">
                <base-input name="select" class="w-100 ml-2 mr-2">
                  <el-select v-model="tempSearchQuery" filterable placeholder="Select value">
                    <el-option v-for="option in selectOptions" :key="option.label" :label="option.label"
                      :value="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-12 col-md-2 d-flex justify-content-center justify-content-lg-start">
                <base-button class="ml-2 mt-0 mb-4 mr-2" size="md" type="primary"
                  @click="handleSearchChange">Search</base-button>
              </div>
            </div>
            <el-table :data="queriedDataWithFullName" row-key="id" header-row-class-name="thead-light"
              @selection-change="selectionChange" @sort-change="handleSortChange">
              <el-table-column label="slNo" prop="slNo" min-width="100px">
              </el-table-column>
              <el-table-column label="name" prop="name" min-width="170px" sortable>
              </el-table-column>
              <el-table-column label="status" prop="status" min-width="130px">
                <template v-slot:default="props">
                  <div class="col-auto px-0">
                    <span class="badge badge-lg" :class="setStatusColor(props.row.status)">
                      {{ props.row.status }}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="default" prop="isDefault" min-width="140px">
                <template v-slot:default="props">
                  <div v-if=props.row.default class="col-auto">
                    <span class="text-success mr-2"><i class="fa fa-check"></i> </span>
                  </div>
                  <div v-else class="col-auto">
                    <span class="text-warning mr-2"><i class="fa fa-times"></i> </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <template v-slot:footer>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div class="">
                <p v-if="isSuccess" class="card-category">
                  Showing {{ from + 1 }} to {{ Math.min(to, total) }} of {{ total }} entries
                </p>
              </div>
              <base-pagination v-if="isSuccess" class="pagination-no-border" v-model="currentPage" :per-page="perPage"
                :total="total" :page-count="totalPages" @update:modelValue="handleFetchNextPage">
              </base-pagination>
            </div>
          </template>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ElTable,
  ElTableColumn,
  ElSelect,
  ElOption,
  ElInput,
} from "element-plus";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BasePagination from "@/components/BasePagination";
import { emitter } from './emitter';

export default {
  components: {
    BasePagination,
    RouteBreadCrumb,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElTable.name]: ElTable,
    [ElInput.name]: ElInput,
    [ElTableColumn.name]: ElTableColumn,
  },
  computed: {
    pagedData() {
      return this.tableData;
    },
    queriedDataWithFullName() {
      const startIndex = this.from + 1;
      return this.pagedData.map((item, index) => ({
        ...item,
        slNo: startIndex + index,
      }));
    },
    from() {
      return (this.currentPage - 1) * this.perPage;
    },
    to() {
      return Math.min(this.from + this.perPage, this.total);
    },
  },
  data() {
    return {
      statusType: "success",
      perPage: 10,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      totalElements: 0,
      totalPages: 0,
      total: 0,
      searchQuery: '',
      tempSearchQuery: '',
      direction: "DESC",
      sortedColumn: "name",
      propsToSearch: ["name"],
      tableData: [],
      searchedData: [],
      isSuccess: false,
      tempFilterField: '',
      fieldOptions: ['Name', 'Status'],
      filterField: '',
      selectOptions: [],
    };
  },
  methods: {
    setStatusColor(status) {
      return status == "ACTIVE" ? "badge-success" : "badge-warning";
    },
    setTable(pageNo, pageSize, sortBy, direction, filter, filterField) {
      let data = {
        pageNo: pageNo - 1,
        pageSize: pageSize,
        sortBy: sortBy,
        direction: direction,
        filter: filter,
        filterField: filterField,
      };
      this.$store.dispatch("brokerStore/getBrokerDetails", data, { root: true })
        .then(response => {
          this.tableData = response.server.data.brokerDetails;
          this.totalElements = this.tableData.length;
          this.currentPage = response.server.data.currentPage + 1;
          this.totalPages = response.server.data.totalPages;
          this.total = response.server.data.totalElements;
          this.isSuccess = this.tableData.length > 0;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSortChange({ prop, order }) {
      console.log("order and prop", { prop, order })
      let sortProp = prop || 'name';
      let sortOrder = order || 'ascending';
      this.setTable(this.currentPage, this.perPage, sortProp, this.mapSortOrder(sortOrder), this.searchQuery, this.filterField);
    },
    mapSortOrder(order) {
      const orderMap = {
        "ascending": "ASC",
        "descending": "DESC",
      };
      return orderMap[order];
    },
    handlePerPageChange(newPerPage) {
      this.perPage = newPerPage;
      this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
    },
    handleFetchNextPage(newPage) {
      this.currentPage = newPage;
      this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
    },
    handleSearchChange() {
      this.searchQuery = this.tempSearchQuery;
      this.setTable(1, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
    },
    handleTempFieldChange() {
      this.tempSearchQuery = '';
      this.filterField = this.tempFilterField.replace(/ /g, '');
      let data = {
        type: ""
      };
      if (this.filterField == 'Name') {
        data.type = 'broker-name'
      } else if (this.filterField == 'Status') {
        data.type = 'broker-status'
      }
      if (sessionStorage.getItem(data.type + "-reference-data")) {
        this.selectOptions = JSON.parse(sessionStorage.getItem(data.type + "-reference-data"))
      } else {
        this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
          .then(response => {
            this.selectOptions = response.server.data;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.tempFilterField = '';
    this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
    emitter.on('flag-sent', (data) => {
      this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
    });
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
